module.exports = __webpack_public_path__ + "static/media/Berlin.1e73aba2.png";